import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const fetchRefundDetails = refundUuid => ({
  [RSAA]: {
    endpoint: getApiPath(`exp`, `expenses/provider-refund/${refundUuid}`),
    method: 'GET',
    types: [
      types.FETCH_REFUND_DETAILS_REQUEST,
      types.FETCH_REFUND_DETAILS_SUCCESS,
      types.FETCH_REFUND_DETAILS_ERROR,
    ],
  },
})

export const associateExpenseToRefund = (refundUuid, expenseUuid) => ({
  [RSAA]: {
    endpoint: getApiPath(`exp`, `expenses/provider-refund`),
    method: 'PUT',
    body: JSON.stringify({ uuid: refundUuid, expenseUuid }),
    types: [
      types.ASSOCIATE_EXPENSE_REQUEST,
      types.ASSOCIATE_EXPENSE_SUCCESS,
      types.ASSOCIATE_EXPENSE_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_REFUND_DETAILS_REQUEST:
    case types.ASSOCIATE_EXPENSE_REQUEST: {
      return {
        ...state,
        refunds: {
          ...state.refunds,
          busy: true,
          error: null,
        },
      }
    }
    case types.FETCH_REFUND_DETAILS_SUCCESS: {
      return {
        ...state,
        refunds: {
          busy: false,
          refundInfo: payload.refundInfo,
          expenses: payload.expenses,
        },
      }
    }
    case types.FETCH_REFUND_DETAILS_ERROR: {
      return {
        ...state,
        refunds: {
          busy: false,
          error: payload.response.message,
        },
      }
    }

    case types.ASSOCIATE_EXPENSE_SUCCESS: {
      return {
        ...state,
        refunds: {
          ...state.refunds,
          busy: false,
          refundInfo: payload.refundInfo,
          expenses: payload.expenses,
        },
      }
    }
    case types.ASSOCIATE_EXPENSE_ERROR: {
      return {
        ...state,
        refunds: {
          ...state.refunds,
          busy: false,
          error: payload.response.message,
        },
      }
    }
    default:
      return state
  }
}
